exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.flex-list-parent {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n}\r\n\r\n.flex-list-group-item {\r\n    -ms-flex-positive: 1;\r\n        flex-grow: 1;\r\n    margin: 10px;\r\n}\r\n\r\n.filter-btn-group {\r\n    -ms-flex-item-align: end;\r\n        align-self: flex-end;\r\n    margin-bottom: 10px;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.flex-btn-small {\r\n    -ms-flex-positive: 1;\r\n        flex-grow: 1;\r\n    padding: 12px 10px;\r\n}\r\n\r\n.external-link {\r\n    color:#004D8A;        \r\n}\r\n\r\n.result-count {\r\n    margin-top: 12px;\r\n    color: #666666;\r\n}\r\n\r\n.dt-options {\r\n    margin: 20px -15px;    \r\n}\r\n\r\n.row-count-selector {\r\n    border-color: #0069bd;\r\n    text-align-last:center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/src/app/programs/program-list/program-list.component.css
// module id = ../../../../../src/app/programs/program-list/program-list.component.css
// module chunks = main